import { Component } from "@angular/core";

@Component({
    selector: "app-user-layout",
    standalone: false,
    templateUrl: "./user-layout.component.html",
    styleUrl: "./user-layout.component.scss",
})
export class UserLayoutComponent {}
